export const formatDateByLang = (lang: "en" | "fr" | "mg", date: any): string => {
  const d = new Date(date);

  if (isNaN(d.getTime())) {
    throw new Error("Date invalide");
  }

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  // English format: YYYY-MM-DD
  if (lang === "en") {
    return `${year}-${month}-${day}`;
  }

  // French / Malagasy format: DD/MM/YYYY
  if (lang === "fr" || lang === "mg") {
    return `${day}/${month}/${year}`;
  }

  throw new Error("Langue non supportée");
}

export function getYear(date: any): number {
  const d = new Date(date);

  if (isNaN(d.getTime())) {
    throw new Error("Date invalide");
  }

  return d.getFullYear();
}

export const searchTranslationKeys = (
  query: string,
  language: "en" | "fr" | "mg",
  translationData: any,
  keyPrefix: string = 'portfolio.gence.product'
): string => {
  if (!query.trim()) return '';

  const queryLower = query.toLowerCase();
  const matchingKeys: string[] = [];

  for (const [key, value] of Object.entries(translationData)) {
    if (!key.startsWith(keyPrefix)) continue;

    const content = (value as any)?.contents?.[language];
    if (content && content.toLowerCase().includes(queryLower)) {
      matchingKeys.push(key);
    }
  }

  return matchingKeys.join(',');
};